import styled, {css} from 'styled-components';

import {scToTwColour} from '../../theme';

type Props = {
  acceptLabels: string;
  isHovered: boolean;
};
export function DropzoneLabel(props: Props): React.JSX.Element {
  return (
    <P $isHovered={props.isHovered}>
      Drop your data here or click to browse.
      <span>Formats: {props.acceptLabels}</span>
    </P>
  );
}

const P = styled.p<{$isHovered: boolean}>`
  grid-column: 1 / -1;
  padding: 1rem 0;
  margin: 0;
  font-weight: 600;
  transition: all ${({theme}) => theme.transition};

  & > span {
    display: block;
    font-weight: 400;
  }

  ${({$isHovered}) =>
    $isHovered &&
    css`
      &,
      &:hover {
        background-color: ${scToTwColour('theme.colours.blue10')};
      }
    `};

  ${({theme}) => theme.media.md`
    padding: 2.5rem 0;
  `}
`;
DropzoneLabel.displayName = 'DropzoneLabel';

export function DropzoneHover(): React.JSX.Element {
  return <HoverText>Drop your data here or click to browse.</HoverText>;
}

const HoverText = styled.p`
  grid-column: 1 / -1;
  padding: 1rem;
  margin: 0;
  font-weight: 600;
  background-color: ${scToTwColour('theme.colours.blue9')};
  color: ${scToTwColour('theme.colours.white')};

  ${({theme}) => theme.media.md`
    padding: 2.5rem;
  `}
`;

DropzoneLabel.displayName = 'DropzoneLabel';
